require( '@babel/polyfill' );

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
window.axios = require('axios');


String.prototype.titleCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

/**
 * Converts a snake case string to title case.
 * Example: snake_case => Snake Case
 */
String.prototype.snakeToTitle = function () {
    return this.split('_').map(function (item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
    })
        .join(' ');
};

window.moment = require('moment');

require('@chenfengyuan/datepicker');
require('trumbowyg/dist/trumbowyg.js');
require('./plugins/trumbowyg.upload.js');
require('./plugins/trumbowyg.cleanpaste.js');
require('./plugins/trumbowyg.allowtagsfrompaste.js');
require('./plugins/trumbowyg.table.js');
require('./vue');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
};
